import { observable, action } from "mobx";
import axios from "axios";

export default class TituloPaginaStore {

    @observable titulo;
    @observable botoesMobile;
    @observable subtitulo;
    @observable status;

    constructor() {
        this.nome = "";
        this.status = ""
        this.botoesMobile = [];
        // this.subtitulo = null;
    }

    setTituloEStatus(value, status) {
        this.titulo = value;
        this.status = status;
        this.subtitulo = null;
    }

    setTitulo(value) {
        this.titulo = value;
        this.status = null;
        this.subtitulo = null;
    }

    setSubtitulo(value) {
        this.subtitulo = value;
    }

    setStatus(value) {
        this.status = value;
    }

    setBotoesMobile(value) {
        this.botoesMobile = value;
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/stores/TituloPaginaStore.js